import { Link } from 'react-router-dom';

const services = [
  { label: 'Hazardous Material Removal', href: '/services/asbestos-abatement' },
  { label: 'Asbestos Abatement', href: '/services/asbestos-abatement' },
  { label: 'Lead-Based Paint Removal', href: '/services/asbestos-abatement' },
  { label: 'Mold Remediation', href: '/services/asbestos-abatement' },
  { label: 'Disaster Restoration', href: '/services/asbestos-abatement' },
  { label: 'Demolition & Site Cleanup', href: '/services/asbestos-abatement' },
  { label: 'Environmental Consulting', href: '/services/asbestos-abatement' },
];

const locations = [
  { label: 'Colorado Springs', href: '/locations/colorado-springs' },
  { label: 'Denver', href: '/locations/colorado-springs' },
  { label: 'Pueblo', href: '/locations/colorado-springs' },
  { label: 'Front Range', href: '/locations/colorado-springs' },
];

export default function Footer() {
  return (
    <footer className="bg-ecos-charcoal-mid">

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12">

          {/* Brand col */}
          <div className="lg:col-span-4">
            <Link to="/" className="flex items-center mb-5">
              <img
                src="https://www.ecosenvironmental.com/images/brand/logo-light.2504231044093.png"
                alt="ECOS Environmental & Disaster Restoration"
                className="h-10 w-auto object-contain"
              />
            </Link>
            <p className="text-white/50 text-sm leading-relaxed mb-6 max-w-xs">
              Colorado&apos;s certified environmental remediation and disaster restoration specialists. Licensed, insured, and EPA/OSHA compliant for over 20 years.
            </p>

            {/* Contact */}
            <div className="space-y-3 mb-6">
              <a
                href="tel:+18888685420"
                className="flex items-center gap-3 text-white/60 hover:text-white transition-colors cursor-pointer group"
              >
                <div className="w-8 h-8 flex items-center justify-center bg-ecos-green/15 group-hover:bg-ecos-green rounded-sm transition-colors flex-shrink-0">
                  <i className="ri-phone-line text-ecos-green group-hover:text-white text-sm transition-colors"></i>
                </div>
                <span className="text-sm font-medium">888-868-5420</span>
              </a>
              <a
                href="mailto:info@ecosenvironmental.com"
                className="flex items-center gap-3 text-white/60 hover:text-white transition-colors cursor-pointer"
              >
                <div className="w-8 h-8 flex items-center justify-center bg-white/8 rounded-sm flex-shrink-0">
                  <i className="ri-mail-line text-white/50 text-sm"></i>
                </div>
                <span className="text-sm">info@ecosenvironmental.com</span>
              </a>
              <div className="flex items-center gap-3 text-white/40">
                <div className="w-8 h-8 flex items-center justify-center bg-white/8 rounded-sm flex-shrink-0">
                  <i className="ri-map-pin-line text-white/50 text-sm"></i>
                </div>
                <span className="text-sm">12 Locations Across Colorado</span>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <a
                href="https://www.facebook.com/ecosaspen"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-8 h-8 flex items-center justify-center border border-white/15 hover:border-ecos-green hover:text-ecos-green text-white/50 rounded-sm transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-sm"></i>
              </a>
              <a
                href="https://x.com/ecosrestoration"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-8 h-8 flex items-center justify-center border border-white/15 hover:border-ecos-green hover:text-ecos-green text-white/50 rounded-sm transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a
                href="https://www.youtube.com/channel/UCM7mT9_YYdDmEAXER_br5Xw"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-8 h-8 flex items-center justify-center border border-white/15 hover:border-ecos-green hover:text-ecos-green text-white/50 rounded-sm transition-colors cursor-pointer"
              >
                <i className="ri-youtube-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div className="lg:col-span-3">
            <h4 className="text-xs uppercase tracking-widest text-ecos-green font-semibold mb-5">Our Services</h4>
            <ul className="space-y-2.5">
              {services.map((s) => (
                <li key={s.label}>
                  <Link
                    to={s.href}
                    className="text-white/50 hover:text-white text-sm transition-colors cursor-pointer flex items-center gap-2"
                  >
                    <i className="ri-arrow-right-s-line text-ecos-green text-xs"></i>
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company + Locations */}
          <div className="lg:col-span-2">
            <h4 className="text-xs uppercase tracking-widest text-ecos-green font-semibold mb-5">Company</h4>
            <ul className="space-y-2.5 mb-8">
              {[
                { label: 'About ECOS', to: '/about' },
                { label: 'Our Process', to: '/#process' },
                { label: 'Testimonials', to: '/#testimonials' },
                { label: 'Request Assessment', to: '/#assessment' },
              ].map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-white/50 hover:text-white text-sm transition-colors cursor-pointer flex items-center gap-2"
                  >
                    <i className="ri-arrow-right-s-line text-ecos-green text-xs"></i>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <h4 className="text-xs uppercase tracking-widest text-ecos-green font-semibold mb-4">Key Locations</h4>
            <ul className="space-y-2">
              {[
                { label: 'Denver', href: 'https://www.ecosenvironmental.com/denver-co/' },
                { label: 'Aurora', href: 'https://www.ecosenvironmental.com/aurora-co/' },
                { label: 'Boulder', href: 'https://www.ecosenvironmental.com/boulder-co/' },
                { label: 'Colorado Springs', href: '/locations/colorado-springs' },
                { label: 'Aspen', href: 'https://www.ecosenvironmental.com/aspen-co/' },
                { label: 'Grand Junction', href: 'https://www.ecosenvironmental.com/grand-junction-co/' },
              ].map((loc) => (
                <li key={loc.label}>
                  <a
                    href={loc.href}
                    className="text-white/50 hover:text-white text-sm transition-colors cursor-pointer flex items-center gap-2"
                  >
                    <i className="ri-map-pin-line text-ecos-green text-xs"></i>
                    {loc.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Certifications / Emergency */}
          <div className="lg:col-span-3">
            <h4 className="text-xs uppercase tracking-widest text-ecos-green font-semibold mb-5">Certifications</h4>
            <div className="space-y-3 mb-8">
              {[
                { icon: 'ri-shield-star-line', label: 'IICRC Certified' },
                { icon: 'ri-verified-badge-line', label: 'OSHA Compliant' },
                { icon: 'ri-government-line', label: 'EPA Aligned' },
                { icon: 'ri-umbrella-line', label: 'Fully Insured' },
                { icon: 'ri-award-line', label: 'BBB A+ Rated' },
                { icon: 'ri-pulse-line', label: '2025 Pulse of the City Award' },
              ].map((cert) => (
                <div key={cert.label} className="flex items-center gap-3">
                  <div className="w-7 h-7 flex items-center justify-center bg-ecos-green/15 rounded-sm flex-shrink-0">
                    <i className={`${cert.icon} text-ecos-green text-sm`}></i>
                  </div>
                  <span className="text-white/55 text-sm">{cert.label}</span>
                </div>
              ))}
            </div>

            <div className="bg-ecos-green rounded-sm px-5 py-5">
              <p className="text-white font-semibold text-sm mb-1">24/7 Emergency Response</p>
              <p className="text-white/70 text-xs mb-3">Environmental emergencies require immediate action.</p>
              <a
                href="tel:+18888685420"
                className="block text-center bg-white text-ecos-green font-semibold text-sm py-2.5 rounded-sm cursor-pointer whitespace-nowrap hover:bg-ecos-slate transition-colors"
              >
                Call Now: 888-868-5420
              </a>
            </div>
          </div>

        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/8">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs">
            &copy; 2026 ECOS Environmental &amp; Disaster Restoration, Inc. All rights reserved. Licensed &amp; Insured Environmental Contractor — Colorado.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" rel="nofollow" className="text-white/30 hover:text-white/60 text-xs transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" rel="nofollow" className="text-white/30 hover:text-white/60 text-xs transition-colors cursor-pointer">Terms of Service</a>
          </div>
        </div>
      </div>

    </footer>
  );
}
